import { AnyIfEmpty } from 'react-redux';
import { GET_SIGNUP_REQUEST, GET_SIGNUP_SUCCESS, GET_SIGNUP_FAILURE, RESET_VALIDATION_MESSAGE } from '../constants/signup.constant';

const initialState = {
    loading: false,
    data: [],
    signUpError: '',
};

const signupReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case GET_SIGNUP_REQUEST:
            return {
                ...state,
                loading: true,
                signUpError: '',
            };

        case GET_SIGNUP_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                signUpError: '',
            };
        case GET_SIGNUP_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                signUpError: action.payload,
            };
        case RESET_VALIDATION_MESSAGE:
            return {
                ...state,
                loading: false,
                data: [],
                signUpError: '',
            };
        default:
            return state;
    }
};

export default signupReducer;
